module.exports = __webpack_public_path__ + "img/home_lenders.fa4a0ee0.jpg";